import API from '@/api/api.js'


export default class ValidationAPIList {
   constructor() {
    let api = new API();
    this.api = api;
  }

    getValidationRule(dest, success, error) {
      // console.log(dest);
      // let parameters = {};

    this.api.post(dest+"?validate=1",{},
      (json) => {
      success(json);
    }, (err) => {
      error(err);
    });
  }


}



// WEBPACK FOOTER //
// ./src/api/Validation/apiList.js